import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-files-path',
  templateUrl: './files-path.component.html',
  styleUrls: ['./files-path.component.scss']
})
export class FilesPathComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      groupLogoBlue: ['',Validators.required],
      groupLogoWhite: ['', Validators.required],
      engineeringLogoBlue: ['',Validators.required],
      engineeringLogoWhite: ['', Validators.required],
      degreeLogoBlue: ['',Validators.required],
      degreeLogoWhite: ['', Validators.required],
      schoolOfBusinessLogoBlue: ['',Validators.required],
      schoolOfBusinessLogoWhite: ['', Validators.required],
      collegeOfPhysiotherapyLogoBlue: ['',Validators.required],
      collegeOfPhysiotherapyLogoWhite: ['', Validators.required],
      collegeOfHealthScienceLogoBlue: ['',Validators.required],
      collegeOfHealthScienceLogoWhite: ['', Validators.required],
      pucCollegeLogoBlue: ['',Validators.required],
      pucCollegeLogoWhite: ['', Validators.required],
      eveningDegreeCollegeLogoBlue: ['',Validators.required],
      eveningDegreeCollegeLogoWhite: ['', Validators.required],
      homeAbout: ['', Validators.required],
      // newsDetailsBanner: ['', Validators.required],
      // newsBanner: ['', Validators.required],
      footerForbes: ['', Validators.required],
      footerLogo: ['', Validators.required],
      footerNaac: ['', Validators.required],
      // pageAboutUsBanner: ['', Validators.required],
      // iqacBanner: ['', Validators.required],
      // facilitiesBanner: ['', Validators.required],
      // rankingsBanner: ['', Validators.required],
      // admissionsOverviewBanner: ['', Validators.required],
      // placementsOverviewBanner: ['', Validators.required],
      // ourRecruitersBanner: ['', Validators.required],
      ctcImage: ['', Validators.required],
      sectorwiseImage: ['', Validators.required],
      // labsLibrariesBanner: ['', Validators.required],
      // hkbkLifeOverviewBanner: ['', Validators.required],
      // instituteIndustryBanner: ['', Validators.required],
      // learningResourcesBanner: ['', Validators.required],
      // learningResourcesDetailBanner: ['', Validators.required],
      // facultyBanner: ['', Validators.required],
      // contactUsBanner: ['', Validators.required],
      // howToApplyBanner: ['', Validators.required],
      // indianStudentsBanner: ['', Validators.required],
      // internationalStudentsBanner: ['', Validators.required],
      navAbout : ['', Validators.required],
      navInstitutions : ['', Validators.required],
      navPrograms : ['', Validators.required],
      navAdmissions : ['', Validators.required],
      navPlacements : ['', Validators.required],
      navHKBKlife : ['', Validators.required],
      navDepartments : ['', Validators.required],
      navResearchInnovation : ['', Validators.required],
      _id: [''],
    });
    this.http.get<any>(this.api_endpoint+'/filespathfindone/').subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              groupLogoBlue: data.data.groupLogoBlue,
              groupLogoWhite: data.data.groupLogoWhite,
              engineeringLogoBlue: data.data.engineeringLogoBlue,
              engineeringLogoWhite: data.data.engineeringLogoWhite,
              degreeLogoBlue: data.data.degreeLogoBlue,
              degreeLogoWhite: data.data.degreeLogoWhite,
              schoolOfBusinessLogoBlue: data.data.schoolOfBusinessLogoBlue,
              schoolOfBusinessLogoWhite: data.data.schoolOfBusinessLogoWhite,
              collegeOfPhysiotherapyLogoBlue: data.data.collegeOfPhysiotherapyLogoBlue,
              collegeOfPhysiotherapyLogoWhite: data.data.collegeOfPhysiotherapyLogoWhite,
              collegeOfHealthScienceLogoBlue: data.data.collegeOfHealthScienceLogoBlue,
              collegeOfHealthScienceLogoWhite: data.data.collegeOfHealthScienceLogoWhite,
              pucCollegeLogoBlue: data.data.pucCollegeLogoBlue,
              pucCollegeLogoWhite: data.data.pucCollegeLogoWhite,
              eveningDegreeCollegeLogoBlue: data.data.eveningDegreeCollegeLogoBlue,
              eveningDegreeCollegeLogoWhite: data.data.eveningDegreeCollegeLogoWhite,
              homeAbout: data.data.homeAbout,
              footerForbes: data.data.footerForbes,
              footerLogo: data.data.footerLogo,
              footerNaac: data.data.footerNaac,
              ctcImage: data.data.ctcImage,
              sectorwiseImage: data.data.sectorwiseImage,
              navAbout : data.data.navAbout,
              navInstitutions : data.data.navInstitutions,
              navPrograms : data.data.navPrograms,
              navAdmissions : data.data.navAdmissions,
              navPlacements : data.data.navPlacements,
              navHKBKlife : data.data.navHKBKlife,
              navResearchInnovation : data.data.navResearchInnovation,
              navDepartments : data.data.navDepartments,
              _id: data.data._id,
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "groupLogoBlue" : this.Form.value.groupLogoBlue,
        "groupLogoWhite" : this.Form.value.groupLogoWhite,
        "engineeringLogoBlue" : this.Form.value.engineeringLogoBlue,
        "engineeringLogoWhite" : this.Form.value.engineeringLogoWhite,
        "degreeLogoBlue": this.Form.value.degreeLogoBlue,
        "degreeLogoWhite": this.Form.value.degreeLogoWhite,
        "schoolOfBusinessLogoBlue": this.Form.value.schoolOfBusinessLogoBlue,
        "schoolOfBusinessLogoWhite": this.Form.value.schoolOfBusinessLogoWhite,
        "collegeOfPhysiotherapyLogoBlue": this.Form.value.collegeOfPhysiotherapyLogoBlue,
        "collegeOfPhysiotherapyLogoWhite": this.Form.value.collegeOfPhysiotherapyLogoWhite,
        "collegeOfHealthScienceLogoBlue": this.Form.value.collegeOfHealthScienceLogoBlue,
        "collegeOfHealthScienceLogoWhite": this.Form.value.collegeOfHealthScienceLogoWhite,
        "pucCollegeLogoBlue": this.Form.value.pucCollegeLogoBlue,
        "pucCollegeLogoWhite": this.Form.value.pucCollegeLogoWhite,
        "eveningDegreeCollegeLogoBlue": this.Form.value.eveningDegreeCollegeLogoBlue,
        "eveningDegreeCollegeLogoWhite": this.Form.value.eveningDegreeCollegeLogoWhite,
        "homeAbout" : this.Form.value.homeAbout,
        "footerForbes" : this.Form.value.footerForbes,
        "footerLogo" : this.Form.value.footerLogo,
        "footerNaac" : this.Form.value.footerNaac,
        "ctcImage" : this.Form.value.ctcImage,
        "sectorwiseImage" : this.Form.value.sectorwiseImage,
        "navAbout" : this.Form.value.navAbout,
        "navInstitutions" : this.Form.value.navInstitutions,
        "navPrograms" : this.Form.value.navPrograms,
        "navAdmissions" : this.Form.value.navAdmissions,
        "navPlacements" : this.Form.value.navPlacements,
        "navHKBKlife" : this.Form.value.navHKBKlife,
        "navResearchInnovation" : this.Form.value.navResearchInnovation,
        "navDepartments" : this.Form.value.navDepartments,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/filespath', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "groupLogoBlue" : this.Form.value.groupLogoBlue,
        "groupLogoWhite" : this.Form.value.groupLogoWhite,
        "engineeringLogoBlue" : this.Form.value.engineeringLogoBlue,
        "engineeringLogoWhite" : this.Form.value.engineeringLogoWhite,
        "degreeLogoBlue": this.Form.value.degreeLogoBlue,
        "degreeLogoWhite": this.Form.value.degreeLogoWhite,
        "schoolOfBusinessLogoBlue": this.Form.value.schoolOfBusinessLogoBlue,
        "schoolOfBusinessLogoWhite": this.Form.value.schoolOfBusinessLogoWhite,
        "collegeOfPhysiotherapyLogoBlue": this.Form.value.collegeOfPhysiotherapyLogoBlue,
        "collegeOfPhysiotherapyLogoWhite": this.Form.value.collegeOfPhysiotherapyLogoWhite,
        "collegeOfHealthScienceLogoBlue": this.Form.value.collegeOfHealthScienceLogoBlue,
        "collegeOfHealthScienceLogoWhite": this.Form.value.collegeOfHealthScienceLogoWhite,
        "pucCollegeLogoBlue": this.Form.value.pucCollegeLogoBlue,
        "pucCollegeLogoWhite": this.Form.value.pucCollegeLogoWhite,
        "eveningDegreeCollegeLogoBlue": this.Form.value.eveningDegreeCollegeLogoBlue,
        "eveningDegreeCollegeLogoWhite": this.Form.value.eveningDegreeCollegeLogoWhite,
        "homeAbout" : this.Form.value.homeAbout,
        "footerForbes" : this.Form.value.footerForbes,
        "footerLogo" : this.Form.value.footerLogo,
        "footerNaac" : this.Form.value.footerNaac,
        "ctcImage" : this.Form.value.ctcImage,
        "sectorwiseImage" : this.Form.value.sectorwiseImage,
        "navAbout" : this.Form.value.navAbout,
        "navInstitutions" : this.Form.value.navInstitutions,
        "navPrograms" : this.Form.value.navPrograms,
        "navAdmissions" : this.Form.value.navAdmissions,
        "navPlacements" : this.Form.value.navPlacements,
        "navHKBKlife" : this.Form.value.navHKBKlife,
        "navResearchInnovation" : this.Form.value.navResearchInnovation,
        "navDepartments" : this.Form.value.navDepartments,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/filespath', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }


}
